export default "__VITE_ASSET__CyNvmZ_Q__"